import React from 'react';

export {
    NoResults
}

function NoResults() {
    return (
        <p className="lead text-center">No results found.</p>
    )
}